/**
 * IVY Cart ↔ PDP Sync
 * - Fetches cart quantity for current product on load
 * - Updates quantity input + "X in cart" label when cart changes
 * - Fires on cart:change, cart:refresh, and Shopify cart update events
 */
(function () {
  'use strict';

  function getVariantId() {
    var inp = document.querySelector('input[name="id"]');
    return inp ? inp.value : null;
  }

  function getProductId() {
    var el = document.querySelector('product-info[data-product-id]');
    return el ? el.dataset.productId : null;
  }

  function updatePdpFromCart(cart) {
    var variantId = getVariantId();
    if (!variantId) return;

    var cartItem = (cart.items || []).find(function (item) {
      return String(item.variant_id) === String(variantId);
    });
    var cartQty = cartItem ? cartItem.quantity : 0;

    // Update quantity input value
    var qtyInput = document.querySelector('.quantity__input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = cartQty > 0 ? cartQty : (qtyInput.dataset.min || 1);
      qtyInput.dataset.cartQuantity = cartQty;
      // Trigger change so price-per-item updates
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update "X in cart" label
    var cartLabel = document.querySelector('.quantity-cart');
    var cartLabelWrapper = document.querySelector('#QuantityRulesCart-' + (document.querySelector('[id^="QuantityRulesCart-"]') || {}).id);
    var cartWrappers = document.querySelectorAll('[id^="QuantityRulesCart-"]');
    cartWrappers.forEach(function (wrapper) {
      if (cartQty > 0) {
        wrapper.classList.remove('hidden');
        var span = wrapper.querySelector('.quantity-cart');
        if (span) span.textContent = '(' + cartQty + ' in cart)';
      } else {
        wrapper.classList.add('hidden');
      }
    });

    // Update ivy-qty-grid subtotal if visible
    var subPrice = document.querySelector('[data-ivy-subtotal-price]');
    var subTotal = document.querySelector('[data-ivy-subtotal-total]');
    var perUnit  = document.querySelector('[data-ivy-subtotal-per-unit]');
    if (subPrice && cartQty > 0) {
      var unitPriceCents = parseInt(qtyInput ? qtyInput.dataset.cartQuantity : 0, 10);
      // Try to get price from selected tile
      var selectedTile = document.querySelector('.ivy-qty-grid__option.is-selected');
      if (selectedTile) {
        var tilePrice = parseInt(selectedTile.dataset.price, 10);
        var fmt = function(cents) {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
        };
        subPrice.textContent = fmt(tilePrice);
        if (subTotal) subTotal.textContent = fmt(tilePrice * cartQty);
        if (perUnit) perUnit.textContent = '(' + fmt(tilePrice) + '/count)';
      }
    }
  }

  function fetchCartAndSync() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(updatePdpFromCart)
      .catch(function () {});
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', fetchCartAndSync);

  // Listen for cart update events (fired by theme drawer, cart-drawer.js, etc.)
  var cartEvents = [
    'cart:change',
    'cart:refresh',
    'cart:updated',
    'cart-update',
  ];
  cartEvents.forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      if (e.detail && e.detail.cart) {
        updatePdpFromCart(e.detail.cart);
      } else {
        fetchCartAndSync();
      }
    });
  });

  // Also observe cart bubble count changes (fallback)
  var cartBubble = document.querySelector('.cart-count-bubble, [data-cart-count]');
  if (cartBubble) {
    new MutationObserver(function () {
      fetchCartAndSync();
    }).observe(cartBubble, { childList: true, subtree: true, characterData: true });
  }

  // ── Remove from Cart button ──────────────────────────────────────────
  function handleRemoveClick(btn) {
    var variantId = String(btn.dataset.variantId);
    if (!variantId || btn.dataset.removing === '1') return;

    btn.dataset.removing = '1';
    btn.style.opacity = '0.4';

    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var item = (cart.items||[]).find(function(i){ return String(i.variant_id) === variantId; });
        if(!item){ btn.dataset.removing=''; btn.style.opacity=''; return; }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        })
        .then(function(r){ return r.json(); })
        .then(function(updatedCart){
          updatePdpFromCart(updatedCart);

              // Update header cart count
              var count = updatedCart.item_count || 0;
              // cart-count custom element (this theme)
              document.querySelectorAll('cart-count').forEach(function(el){
                el.textContent = count;
                el.setAttribute('aria-label', count + ' items');
                if(count === 0) el.setAttribute('hidden', '');
                else el.removeAttribute('hidden');
              });
              // fallback selectors
              document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-indicator, .cart-badge').forEach(function(el){
                el.textContent = count;
              });
              document.querySelectorAll('.cart-count-bubble').forEach(function(b){
                b.style.display = count > 0 ? '' : 'none';
              });

              // Fire all possible cart refresh events
              ['cart:change','cart:updated','cart:refresh','cart-update'].forEach(function(evt){
                document.dispatchEvent(new CustomEvent(evt, { bubbles: true, detail: { cart: updatedCart } }));
              });

              // Reload cart drawer via fetch (most reliable)
              fetch('/cart', { headers: { 'Accept': 'application/json' } }).catch(function(){});

              // Shopify legacy
              if(window.Shopify && Shopify.onCartUpdate) Shopify.onCartUpdate(updatedCart);

              // Refresh cart drawer via theme's own method
              var drawer = document.querySelector('cart-drawer');
              if(drawer){
                if(typeof drawer.onCartRefresh === 'function') drawer.onCartRefresh();
                else if(typeof drawer.renderContents === 'function') drawer.renderContents({ cart: updatedCart });
                else if(typeof drawer.refresh === 'function') drawer.refresh();
              }
          });
      })
      .catch(function(e){ console.error('[ivy-remove]', e); })
      .finally(function(){ btn.dataset.removing=''; btn.style.opacity=''; });
  }

  function initRemoveButton() {
    // Use event delegation on document — survives DOM re-renders
    if (document._ivyRemoveInit) return;
    document._ivyRemoveInit = true;
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.ivy-remove-from-cart');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleRemoveClick(btn);
    });
  }

  // Run with multiple fallbacks to handle defer/async timing
  function tryInit() {
    initRemoveButton();
    fetchCartAndSync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
  // Extra retry for themes that render quantity blocks after JS load
  setTimeout(initRemoveButton, 500);
  setTimeout(initRemoveButton, 1500);

})();

// ── Styles for remove button — override theme button styles ───────────
(function () {
  var style = document.createElement('style');
  style.textContent = [
    'button.ivy-remove-from-cart,',
    '.ivy-remove-from-cart {',
    '  all: unset !important;',
    '  display: inline-flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  width: 18px !important;',
    '  height: 18px !important;',
    '  min-width: 18px !important;',
    '  min-height: 18px !important;',
    '  border-radius: 50% !important;',
    '  cursor: pointer !important;',
    '  color: #999 !important;',
    '  margin-left: 6px !important;',
    '  flex-shrink: 0 !important;',
    '  transition: color .15s !important;',
    '  padding: 0 !important;',
    '  background: transparent !important;',
    '  border: none !important;',
    '  box-shadow: none !important;',
    '  line-height: 1 !important;',
    '}',
    'button.ivy-remove-from-cart:hover,',
    '.ivy-remove-from-cart:hover {',
    '  color: #dc2626 !important;',
    '}',
  ].join('\n');
  document.head.appendChild(style);
})();
